<template>
<div
	class="view view-finished"
>

	<banner />

	<div class="main-content main-content--max-width">

		<div class="container">

			<div class="page-header">
				<h1 class="content-title">You've finished!</h1>

				<div class="page-header__text">
					Thank you for using Looped in. Want something else from NAT? See below!
				</div>
			</div>

			<div class="page-section">
				<h2 class="page-section__heading">Do you want to inform someone else?</h2>
				<p>You can start again to inform someone different, don't worry - any links you've generated will still work!</p>
				<router-link
					:to="{ name: $GLOBALS.ROUTE_HOME }"
					tag="button"
					class="btn btn--quaternary btn--full btn--tall btn--centered"
					@click.native="pushToDataLayer('lets-go-again-click')"
				>
					Let's go again!
				</router-link>
			</div>

			<div class="page-section">
				<h2 class="page-section__heading">Here are some useful links</h2>

				<div class="link-list">
					<div class="link-list__item">
						<a href="https://www.nat.org.uk/" target="_blank" rel="noopener" class="link-list__link">
							www.nat.org.uk
						</a>
					</div>
					<div class="link-list__item">
						<a href="https://www.nat.org.uk/we-inform/do-i-have-hiv" target="_blank" rel="noopener" class="link-list__link">
							www.nat.org.uk/we-inform/do-i-have-hiv
						</a>
					</div>
					<div class="link-list__item">
						<a href="https://www.nat.org.uk/we-inform/do-i-understand-hiv" target="_blank" rel="noopener" class="link-list__link">
							www.nat.org.uk/we-inform/do-i-understand-hiv
						</a>
					</div>
				</div>
			</div>

			<div class="page-section">
				<h2 class="page-section__heading">Ways you can get involved</h2>
				<p>NAT is the UK's HIV policy and campaigns charity. Do you want to join in on our work to change HIV and bust stigma? Join our <a href="https://www.nat.org.uk/we-need-you/get-involved/hiv-activists" target="_blank" rel="noopener">Activists' Network</a>, and if you're living with HIV, <a href="mailto:sean.o'neill@nat.org.uk" target="_blank" rel="noopener">get in touch</a> to see how we can work together.</p>
				<a href="https://www.nat.org.uk" target="_blank" rel="noopener" class="btn btn--square btn--tall btn--centered">
					<svg svg-inline="" focusable="false" role="presentation" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3M8 12h8" fill="none" stroke="#0f0f0f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
					<span>Visit the NAT website at https://www.nat.org.uk</span>
				</a>
			</div>

		</div>

	</div>

</div>
</template>

<script>
// Mixins
import { tagManager } from '@/mixins/tag-manager.js';

// Components
import Banner from '@/components/blocks/Banner.vue';

import * as GLOBALS from '@/globals';
import router from '@/router';

export default {
	mixins: [tagManager],
	components: {
		Banner
	},
	beforeRouteEnter(to, from, next) {
		if (from.name === GLOBALS.ROUTE_SHARE_CONTENT) {
			next();
		} else {
			router.push({
				name: GLOBALS.ROUTE_HOME
			});
		}
	}
};
</script>
